import { useMemo, useRef } from 'react';

import isEqual from 'lodash-es/isEqual';

const useDeepCompareMemoize = (dependencies: React.DependencyList) => {
  const dependenciesRef = useRef<React.DependencyList>(dependencies);
  const signalRef = useRef<number>(0);

  if (!isEqual(dependencies, dependenciesRef.current)) {
    dependenciesRef.current = dependencies;
    signalRef.current += 1;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => dependenciesRef.current, [signalRef.current]);
};

export const useDeepCompareMemo = <T>(
  factory: () => T,
  dependencies: React.DependencyList,
) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(factory, useDeepCompareMemoize(dependencies));
};
